import React, { useEffect, useRef, useState } from 'react';
import { 
  FaPhoneAlt, FaMobileAlt, FaMapMarkerAlt, FaEnvelope, 
  FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn,
  FaYoutube, FaArrowRight, FaPaperPlane, FaUser,
  FaRegClock, FaGlobe, FaWhatsapp
} from 'react-icons/fa';
import { MdEmail, MdLocationOn, MdPhone, MdSend } from 'react-icons/md';
import {sendHtmlEmail} from '../emailapi';

const ContactSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const [mapError, setMapError] = useState(false);
  const sectionRef = useRef(null);
  const mapRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setIsVisible(true);
      },
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  // Load Google Maps with error handling
  useEffect(() => {
    // Check if Google Maps API is already loaded
    if (window.google && window.google.maps) {
      initMap();
    } else {
      // Load Google Maps API script with error handling
      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=YOUR_API_KEY_HERE&libraries=places&callback=initMapCallback`;
      script.async = true;
      script.defer = true;
      
      // Global callback for map initialization
      window.initMapCallback = () => {
        initMap();
        delete window.initMapCallback;
      };
      
      script.onerror = () => {
        console.error('Failed to load Google Maps');
        setMapError(true);
      };
      
      document.head.appendChild(script);
    }

    return () => {
      if (window.initMapCallback) {
        delete window.initMapCallback;
      }
    };
  }, []);

  const initMap = () => {
    try {
      if (!mapRef.current) return;
      
      const location = { lat: 26.8467, lng: 80.9462 };
      
      const mapOptions = {
        center: location,
        zoom: 15,
        styles: [
          {
            featureType: "all",
            elementType: "geometry",
            stylers: [{ color: "#f5f5f5" }]
          },
          {
            featureType: "water",
            elementType: "geometry",
            stylers: [{ color: "#c9e9ff" }]
          },
          {
            featureType: "road",
            elementType: "geometry",
            stylers: [{ color: "#ffffff" }]
          },
          {
            featureType: "landscape",
            elementType: "geometry",
            stylers: [{ color: "#f5f5f5" }]
          }
        ]
      };

      const map = new window.google.maps.Map(mapRef.current, mapOptions);

      // Add marker
      const marker = new window.google.maps.Marker({
        position: location,
        map: map,
        title: "RDS SNATAKOTTAR MAHAVIDYALAY",
        animation: window.google.maps.Animation.DROP,
        icon: {
          url: "https://maps.google.com/mapfiles/ms/icons/red-dot.png",
          scaledSize: new window.google.maps.Size(40, 40)
        }
      });

      // Add info window
      const infoWindow = new window.google.maps.InfoWindow({
        content: `
          <div style="padding: 10px;">
            <h3 style="font-weight: bold; margin-bottom: 5px;">RDS SNATAKOTTAR MAHAVIDYALAY</h3>
            <p style="margin: 0;">Uttar Pradesh, India</p>
            <p style="margin: 5px 0 0 0; font-size: 12px;">Contact: 9721707111</p>
          </div>
        `
      });

      marker.addListener("click", () => {
        infoWindow.open(map, marker);
      });

      // Open info window by default
      infoWindow.open(map, marker);
    } catch (error) {
      console.error('Error initializing map:', error);
      setMapError(true);
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    await sendHtmlEmail('techtviklabs@gmail.com','jhhj',formData);
    alert('Thank you for contacting us! We will get back to you soon.');
    setFormData({ name: '', email: '', phone: '', message: '' });
  };

  const contactInfo = [
    {
      icon: FaPhoneAlt,
      title: "Phone",
      value: "9721707111",
      subValue: "Mon-Fri, 9am-6pm",
      color: "from-blue-600 to-cyan-500",
      bgColor: "bg-blue-50"
    },
    {
      icon: FaMobileAlt,
      title: "Mobile",
      value: "+91 7275 370 808",
      subValue: "24/7 Support Available",
      color: "from-green-500 to-emerald-500",
      bgColor: "bg-green-50"
    },
    {
      icon: FaMapMarkerAlt,
      title: "Address",
      value: "RDS SNATAKOTTAR MAHAVIDYALAY",
      subValue: "Uttar Pradesh, India",
      color: "from-blue-300 to-blue-700",
      bgColor: "bg-purple-50"
    },
    {
      icon: FaEnvelope,
      title: "E-mail",
      value: "rdscollege0342@gmail.com",
      subValue: "info@rdsgroupofcolleges.com",
      color: "from-orange-500 to-red-500",
      bgColor: "bg-orange-50"
    }
  ];

  // Updated socialLinks with actual URLs
  const socialLinks = [
    { 
      icon: FaFacebookF, 
      name: "Facebook", 
      color: "bg-blue-600", 
      hover: "hover:bg-blue-700",
      url: "https://www.facebook.com/rdspharmacy"
    },
    { 
      icon: FaTwitter, 
      name: "Twitter", 
      color: "bg-sky-500", 
      hover: "hover:bg-sky-600",
      url: "#" // Add Twitter URL if available
    },
    { 
      icon: FaInstagram, 
      name: "Instagram", 
      color: "bg-pink-600", 
      hover: "hover:bg-pink-700",
      url: "https://www.instagram.com/rdsgroup_of_colleges?igsh=MTNma2x6cTBwdGJwdA=="
    },
    { 
      icon: FaLinkedinIn, 
      name: "LinkedIn", 
      color: "bg-blue-700", 
      hover: "hover:bg-blue-800",
      url: "#" // Add LinkedIn URL if available
    },
    { 
      icon: FaYoutube, 
      name: "YouTube", 
      color: "bg-red-600", 
      hover: "hover:bg-red-700",
      url: "https://youtube.com/@rdscollegeofpharmacy8349?si=Onm4n5PHvFADYa4q"
    },
    { 
      icon: FaWhatsapp, 
      name: "WhatsApp", 
      color: "bg-green-500", 
      hover: "hover:bg-green-600",
      url: "#" // Add WhatsApp link if available
    }
  ];

  return (
    <section ref={sectionRef} className="w-full py-16 bg-gradient-to-b from-red-50 via-blue-50/20 to-white">
      <div className="w-full max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className={`text-center mb-12 transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-3">
            Contact Us
          </h2>
          <div className="w-20 h-1 bg-gradient-to-r from-blue-600 to-indigo-500 mx-auto rounded-full mb-4"></div>
          <p className="text-gray-600 text-base max-w-2xl mx-auto">
            Have questions? We'd love to hear from you. Send us a message and we'll respond as soon as possible.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-8">
          {/* Left Side - Contact Info */}
          <div className={`space-y-6 transition-all duration-700 delay-200 ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-10'}`}>
            {/* Contact Cards */}
            <div className="grid sm:grid-cols-2 gap-4">
              {contactInfo.map((info, idx) => (
                <div key={idx} className={`${info.bgColor} rounded-2xl p-5 hover:shadow-lg transition-all duration-300 hover:-translate-y-1`}>
                  <div className={`w-12 h-12 bg-gradient-to-br ${info.color} rounded-xl flex items-center justify-center mb-3`}>
                    <info.icon className="text-white text-xl" />
                  </div>
                  <h3 className="text-lg font-bold text-gray-800 mb-1">{info.title}</h3>
                  <p className="text-gray-700 font-medium text-sm">{info.value}</p>
                  <p className="text-gray-500 text-xs mt-1">{info.subValue}</p>
                </div>
              ))}
            </div>

            {/* Office Hours */}
            <div className="bg-white rounded-2xl p-5 shadow-md border border-gray-100">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center">
                  <FaRegClock className="text-blue-600 text-lg" />
                </div>
                <h3 className="text-lg font-bold text-gray-800">Office Hours</h3>
              </div>
              <div className="space-y-2">
                <div className="flex justify-between items-center pb-2 border-b border-gray-100">
                  <span className="text-gray-600 text-sm">Monday - Friday</span>
                  <span className="text-gray-800 font-semibold text-sm">9:00 AM - 6:00 PM</span>
                </div>
                <div className="flex justify-between items-center pb-2 border-b border-gray-100">
                  <span className="text-gray-600 text-sm">Saturday</span>
                  <span className="text-gray-800 font-semibold text-sm">10:00 AM - 4:00 PM</span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-gray-600 text-sm">Sunday</span>
                  <span className="text-gray-500 text-sm">Closed</span>
                </div>
              </div>
            </div>

            {/* Social Links */}
            <div className="bg-white rounded-2xl p-5 shadow-md border border-gray-100">
              <h3 className="text-lg font-bold text-gray-800 mb-4">Follow Us</h3>
              <div className="flex flex-wrap gap-3">
                {socialLinks.map((social, idx) => (
                  <a
                    key={idx}
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`${social.color} ${social.hover} w-10 h-10 rounded-full flex items-center justify-center text-white transition-all duration-300 hover:scale-110 hover:shadow-lg`}
                    aria-label={social.name}
                  >
                    <social.icon className="text-sm" />
                  </a>
                ))}
              </div>
            </div>
          </div>

          {/* Right Side - Contact Form */}
          <div className={`transition-all duration-700 delay-300 ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-10'}`}>
            <div className="bg-white rounded-2xl shadow-xl overflow-hidden border border-gray-100">
              <div className="bg-gradient-to-r from-blue-600 to-indigo-600 px-6 py-4">
                <h3 className="text-xl font-bold text-white">Contact With Us</h3>
                <p className="text-blue-100 text-sm mt-1">Fill the form below and we'll get back to you</p>
              </div>
              
              <form onSubmit={handleSubmit} className="p-6 space-y-4">
                {/* Name Field */}
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">Enter Full Name</label>
                  <div className="relative">
                    <FaUser className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-sm" />
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                      className="w-full pl-10 pr-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:border-blue-600 focus:ring-2 focus:ring-blue-200 transition-all duration-300"
                      placeholder="Your Name"
                    />
                  </div>
                </div>

                {/* Email Field */}
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">Your Email</label>
                  <div className="relative">
                    <MdEmail className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-sm" />
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      className="w-full pl-10 pr-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:border-blue-600 focus:ring-2 focus:ring-blue-200 transition-all duration-300"
                      placeholder="your@email.com"
                    />
                  </div>
                </div>

                {/* Phone Field */}
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">Phone Number</label>
                  <div className="relative">
                    <FaPhoneAlt className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-sm" />
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      required
                      className="w-full pl-10 pr-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:border-blue-600 focus:ring-2 focus:ring-blue-200 transition-all duration-300"
                      placeholder="Your Phone Number"
                    />
                  </div>
                </div>

                {/* Message Field */}
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">Your Message</label>
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    rows="4"
                    required
                    className="w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:border-blue-600 focus:ring-2 focus:ring-blue-200 transition-all duration-300 resize-none"
                    placeholder="Write your message here..."
                  ></textarea>
                </div>

                {/* Submit Button */}
                <button
                  type="submit"
                  className="w-full py-3 bg-gradient-to-r from-blue-600 to-indigo-600 text-white rounded-xl font-semibold hover:shadow-lg transition-all duration-300 flex items-center justify-center gap-2 group"
                >
                  <span>Send Message</span>
                  <FaPaperPlane className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform text-sm" />
                </button>

                <p className="text-center text-xs text-gray-400 mt-3">
                  We'll never share your information with anyone else.
                </p>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;